import React, { useEffect } from 'react';
import style from './index.module.scss';
import classnames from 'classnames';
import { apis, apiHolder as api } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import IconCard from '@web-common/components/UI/IconCard';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const storeApi = api.api.getDataStoreApi();
const RequestReadReceipt = ({ id, account }) => {
    const sendMDN = () => {
        trackApi.track('pcMail_click_button_readReceipt_mailDetailPage', { buttonName: '发送已读回执' });
        MailApi.handleSendMDN(id, account)
            .then(() => {
            MailApi.doMarkMail(false, id, 'requestReadReceiptLocal', undefined, undefined, undefined, account);
            message.success('回执发送成功');
            storeApi.get('receiptDoneIds').then(res => {
                storeApi.put('receiptDoneIds', res.data + id);
            });
        })
            .catch(() => {
            message.success('回执发送失败，请重试');
        });
    };
    const notSendMDN = () => {
        trackApi.track('pcMail_click_button_readReceipt_mailDetailPage', { buttonName: '不发送已读回执' });
        MailApi.doMarkMail(false, id, 'requestReadReceiptLocal', undefined, undefined, undefined, account);
        storeApi.get('receiptDoneIds').then(res => {
            storeApi.put('receiptDoneIds', res.data + id);
        });
    };
    useEffect(() => {
        trackApi.track('pcMail_show_readReceipt_mailDetailPage');
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.wrapper },
            React.createElement("div", { className: style.desc },
                React.createElement(IconCard, { type: "tongyong_youxiang4", className: "dark-invert" }),
                React.createElement("span", { className: style.descText }, "\u53D1\u4EF6\u4EBA\u5E0C\u671B\u5F97\u5230\u4F60\u6536\u5230\u90AE\u4EF6\u7684\u56DE\u6267\uFF0C\u662F\u5426\u53D1\u9001\uFF1F")),
            React.createElement("div", { className: style.btnwrap },
                React.createElement("span", { className: classnames(style.btn), onClick: sendMDN }, "\u53D1\u9001"),
                React.createElement("span", { className: classnames(style.btn, style.nosend), onClick: notSendMDN }, "\u4E0D\u53D1\u9001")))));
};
export default RequestReadReceipt;
